module.exports = __webpack_public_path__ + "img/background.0c52ef07.jpg";